import { Col, Dropdown, MenuProps, Row } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import Logo from '../assets/Logo.svg';
import { useMsal } from '@azure/msal-react';
import { globalAtom, globalState } from '../store/atom';
import { useSetAtom } from 'jotai';

const Header = () => {
  const { accounts, instance } = useMsal();
  const setAtom = useSetAtom(globalAtom);

  const handleClick = async () => {
    setAtom(globalState);
    instance.logout();
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div onClick={handleClick}>
          <LogoutOutlined /> <span className="pl-2">Logout</span>
        </div>
      ),
      danger: true,
    },
  ];

  return (
    <div className="flex items-center justify-center bg-[#003568]">
      <Row className="w-full px-4 text-white items-center justify-center">
        <Col span={12}>
          <div>
            <img src={Logo} alt="spark-talent-logo" />
          </div>
        </Col>
        <Col span={12}>
          <div className="ml-auto w-fit">
            <div className="grid gap-6 grid-flow-col">
              <div>
                <Dropdown menu={{ items }} placement="bottom" arrow>
                  <span>{accounts[0]?.name || ''}</span>
                </Dropdown>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Header;
